module.exports = __webpack_public_path__ + "img/subtraction5.8763eac9.svg";